const footer = {
  copyright: "Hak Cipta © 2022 HitPaw. Co., Ltd. Seluruh Hak Cipta.",
};

export default footer;
